// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Request Code Section Styles */
.request-code-section {
  display: flex;
  flex-direction: column;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #ffffff;
  overflow: hidden;
}

.request-code-section .code-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #d9d9d9;
}

.request-code-section .section-title {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5714285714285714em;
  color: rgba(0, 0, 0, 0.88);
}

.request-code-section .format-selector-dropdown {
  min-width: 90px;
}

.request-code-section .format-selector-dropdown .ant-select-selector {
  height: 24px !important;
  padding: 0 7px !important;
  font-size: 12px;
  border-color: #d9d9d9;
  border-radius: 4px;
  background: #ffffff;
}

.request-code-section .format-selector-dropdown .ant-select-selection-item {
  line-height: 22px !important;
}

.request-code-section .dropdown-arrow {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.45);
}

.request-code-section .format-icon {
  font-family: 'SF Mono', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}

.request-code-section .code-section-body {
  padding: 16px;
  background: #ffffff;
  font-family: 'Courier Prime', monospace;
  font-size: 12px;
  line-height: 1.33;
  overflow-x: auto;
  min-height: 120px;
}

/* Format Dropdown Menu */
.format-dropdown-menu .ant-select-item {
  padding: 6px 12px;
}

.format-dropdown-menu .ant-select-item-option-content {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/ApiTestSection/requestCodeSection.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0DAA0D;EAC1D,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Request Code Section Styles */\n.request-code-section {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.request-code-section .code-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f5f5f5;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.request-code-section .section-title {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5714285714285714em;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n.request-code-section .format-selector-dropdown {\n  min-width: 90px;\n}\n\n.request-code-section .format-selector-dropdown .ant-select-selector {\n  height: 24px !important;\n  padding: 0 7px !important;\n  font-size: 12px;\n  border-color: #d9d9d9;\n  border-radius: 4px;\n  background: #ffffff;\n}\n\n.request-code-section .format-selector-dropdown .ant-select-selection-item {\n  line-height: 22px !important;\n}\n\n.request-code-section .dropdown-arrow {\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.request-code-section .format-icon {\n  font-family: 'SF Mono', 'Monaco', 'Courier New', monospace;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.request-code-section .code-section-body {\n  padding: 16px;\n  background: #ffffff;\n  font-family: 'Courier Prime', monospace;\n  font-size: 12px;\n  line-height: 1.33;\n  overflow-x: auto;\n  min-height: 120px;\n}\n\n/* Format Dropdown Menu */\n.format-dropdown-menu .ant-select-item {\n  padding: 6px 12px;\n}\n\n.format-dropdown-menu .ant-select-item-option-content {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
